import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type Parameter = {
    productId: string;
    productName: string;
    qtyOrdered: number;
    addIncludes: boolean;
    viewOnly: boolean;
    partNo?: string;
    unitPrice?: number;
    weight?: number;
    length?: number;
    g1?: number;
    g2?: number;
    daysToShip?: string;
};

type HandlerType = Handler<Parameter>;

const DispatchChangeClipboardItem: HandlerType = props => {
    props.dispatch({
        type: "Widgets/Clipboard/SetItem",
        parameter: {
            qtyOrdered: props.parameter.qtyOrdered,
            productId: props.parameter.productId,
            productName: props.parameter.productName,
            addIncludes: props.parameter.addIncludes,
            viewOnly: props.parameter.viewOnly,
            partNo: props.parameter.partNo,
            unitPrice: props.parameter.unitPrice,
            weight: props.parameter.weight,
            length: props.parameter.length,
            g1: props.parameter.g1,
            g2: props.parameter.g2,
            daysToShip: props.parameter.daysToShip,
        },
    });
};

const chain = [DispatchChangeClipboardItem];

const changeClipboardItem = createHandlerChainRunner(chain, "ChangeClipboardItem");
export default changeClipboardItem;
